import React from "react";
import {Shimmer, Box, View} from "@unibuddy/patron";
import {ChatContainer, ChatFooter, ChatScroll} from "@unibuddy/chat-ui";

import ChatHeader from "shared/Chat/components/ChatHeader/ChatHeader";
import {ChatBackButton} from "../../components/ChatBackButton/ChatBackButton";

const LoadingTimeStamp = (
    <Shimmer style={{width: 150, height: 10}} height={10} width={150}>
        <rect x="0" y="0" rx="5" ry="5" width="150" height="10" />
    </Shimmer>
);

const LoadingAvatar = (
    <Shimmer style={{width: 45, height: 45}} height={45} width={45}>
        <circle cx="22.5" cy="22.5" r="22.5" />
    </Shimmer>
);

const LoadingTitle = (
    <Shimmer style={{width: 117, height: 26}} height={26} width={117}>
        <rect x="0" y="0" rx="3" ry="3" width="117" height="6" />
        <rect x="0" y="15" rx="3" ry="3" width="117" height="6" />
    </Shimmer>
);

const LoadingChatMessage1 = (
    <Shimmer style={{width: 200, height: 59}} height={59} width={200}>
        <rect x="0" y="0" rx="12" ry="12" width="200" height="59" />
    </Shimmer>
);

const LoadingChatMessage2 = (
    <Shimmer style={{width: 200, height: 35}} height={35} width={200}>
        <rect x="0" y="0" rx="12" ry="12" width="200" height="35" />
    </Shimmer>
);

const LoadingChatInput = (
    <Shimmer style={{width: "100%", height: 42}} height={42} width="100%">
        <rect x="0" y="0" rx="21" ry="21" width="100%" height="42" />
    </Shimmer>
);

const LoadingSendBtn = (
    <Shimmer style={{width: 42, height: 42}} height={42} width={42}>
        <circle cx="21" cy="21" r="21" />
    </Shimmer>
);

const LoadingAmboMessage = () => (
    <Box
        display="flex"
        paddingLeft={["xxsmall", "xsmall", "small"]}
        gap={["xxsmall", "xsmall", "small"]}
    >
        {LoadingAvatar}
        <View gap="xsmall">
            {LoadingTimeStamp}
            {LoadingChatMessage1}
        </View>
    </Box>
);

const LoadingProspectMessage = () => (
    <View alignItems="flex-end" paddingRight={["xxsmall", "xsmall", "small"]} gap="xsmall">
        {LoadingTimeStamp}
        {LoadingChatMessage2}
    </View>
);

const LoadingFooter = () => (
    <Box display="flex" gap="xsmall">
        {LoadingChatInput}
        <Box display="flex" flexShrink={0}>
            {LoadingSendBtn}
        </Box>
    </Box>
);

export default function LoadingChat() {
    return (
        <Box height={550}>
            <ChatContainer
                borderWidth={1}
                borderColor="#e4e8eb"
                borderRadius="xsmall"
                overflow="hidden"
                height="100%"
            >
                <ChatHeader leftAddon={<ChatBackButton />} rightAddon={<div />}>
                    {LoadingAvatar}
                    <ChatHeader.Title>{LoadingTitle}</ChatHeader.Title>
                </ChatHeader>
                <Box marginTop="medium" />
                <ChatScroll
                    blur={false}
                    loading={false}
                    hasMoreMessages={false}
                    messages={[{id: "1"}, {id: "2"}]}
                >
                    <View gap="medium">
                        <LoadingAmboMessage />
                        <LoadingProspectMessage />
                        <LoadingAmboMessage />
                        <LoadingProspectMessage />
                    </View>
                </ChatScroll>
                <ChatFooter>
                    <LoadingFooter />
                </ChatFooter>
            </ChatContainer>
        </Box>
    );
}
